import {
    BrowserCacheLocation,
    Configuration,
    IPublicClientApplication,
    InteractionType,
    PublicClientApplication,
} from '@azure/msal-browser';

import {
    MSAL_INSTANCE,
    MsalGuardConfiguration,
    MsalInterceptorConfiguration,
    MsalService,
} from '@azure/msal-angular';

import { environment } from '@environments/environment';

export const loginRequest = {
    scopes: [
        'openid',
        'profile',
        'email',
        environment.backendScope
    ],
};

export const protectedResources = {
    backend: {
        endpoint: environment.backendBaseUrl,
        scopes: [environment.backendScope],
    },
};

export const msalConfig: Configuration = {
    auth: {
        clientId: environment.entraClientId,
        authority: environment.entraAuthority,
        knownAuthorities: environment.entraKnownAuthorities,
        redirectUri: environment.redirectUri,
        postLogoutRedirectUri: environment.postLogoutRedirectUri,
    },

    cache: {
        cacheLocation: BrowserCacheLocation.SessionStorage,
        // storeAuthStateInCookie: false,
    },
};

export function MSALInstanceFactory(): IPublicClientApplication {
    return new PublicClientApplication(msalConfig);
}

export const msalInstance: IPublicClientApplication = new PublicClientApplication(msalConfig);
    
export function msalGuardConfigFactory(): MsalGuardConfiguration {
    return {
        interactionType: InteractionType.Redirect,
        authRequest: loginRequest,
    };
}

export function msalInterceptorConfigFactory(): MsalInterceptorConfiguration {
    const protectedResourceMap = new Map<string, Array<string>>();
    // Strict matching (msal-angular v5 default) anchors each URL component, so the path
    // must include a trailing wildcard for the interceptor to match nested routes
    // such as `/api/me`, `/api/contacts`, etc.
    const baseUrl = protectedResources.backend.endpoint;
    const normalizedBaseUrl = baseUrl.endsWith("/") ? baseUrl : `${baseUrl}/`;
    protectedResourceMap.set(
        `${normalizedBaseUrl}*`,
        protectedResources.backend.scopes
    );

    return {
        interactionType: InteractionType.Redirect,
        protectedResourceMap
    };
}